<main>
  <div class="page-container">
    @if (isDesktopLayout) {
      <div class="column left">
        <div class="texts-container">
          <h1 class="main-title-text" [innerHTML]="'LOGIN_PAGE.MAIN_TITLE' | translate: {}"></h1>
          <h2 class="subtitle-text">
            {{ 'ACTIVATE_ACCOUNT_PAGE.SUBTITLE_PREFIX' | translate }}
            <a [routerLink]="['/privacy-policy']">{{ 'ACTIVATE_ACCOUNT_PAGE.SUBTITLE_PRIVACY_POLICY' | translate }}</a>
            {{ 'ACTIVATE_ACCOUNT_PAGE.SUBTITLE_CONNECTOR' | translate }}
            <a [routerLink]="['/tos']">
              {{ 'ACTIVATE_ACCOUNT_PAGE.SUBTITLE_TERMS_OF_SERVICE' | translate }}
            </a>
            .
          </h2>
        </div>
      </div>
    }

    <div class="column right" [class.column--loading]="viewLoading">
      <div class="utils-buttons-wrapper">
        <app-utils-buttons (userLangChanged)="userLangChanged($event)"></app-utils-buttons>
      </div>

      <div class="content-column" [class.content-column--loading]="viewLoading">
        @if (!APIAvailable) {
          <app-activate-account-api-unavailable-view></app-activate-account-api-unavailable-view>
        }

        @if (APIAvailable && viewLoading) {
          <nz-spin
            class="mobiapp-spin no-children xlarge"
            [nzTip]="'COMMON.GENERAL.LOADING_APPLICATION_DATA' | translate"
            nzSize="large"
            [nzSpinning]="true"
            [nzIndicator]="LoadingIndicator"></nz-spin>
        }

        @if (APIAvailable && currentUserLang?.key) {
          <app-activate-account-form-state
            [class.activate-account-form-state--preparing]="viewLoading"></app-activate-account-form-state>
        }
      </div>
    </div>
  </div>
</main>

<ng-template #LoadingIndicator>
  <span nz-icon nzType="loading" class="ant-spin-dot"></span>
</ng-template>
<app-cookie-banner></app-cookie-banner>
